// extracted by mini-css-extract-plugin
export default {"activePowerTable":"ResidualElectricityPower_activePowerTable__xVaEw"};